module.exports = __webpack_public_path__ + "static/favicon-8a61dd6d0058001ed7807d4fa2cef058.png";